import {Injectable} from '@angular/core';
import {BaseDaoService, RefModelNode} from '@q9elements/ui-kit/common';

import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FollowingService extends BaseDaoService {
  constructor() {
    super();
  }

  toggleFollow(node: RefModelNode) {
    const opts = {modelId: node._id, modelType: 'rmn'};

    switch (node.followLevel) {
      case -1:
        return this.follow(opts);
      case 0:
        return this.favourite(opts);
      case 1:
        return this.unfollow(opts);
    }
  }

  follow(opts: any): Observable<any> {
    const url = `${this.apiUrl}/follows`;
    return this.http.post(url, opts);
  }

  unfollow(opts: any): Observable<any> {
    const url = `${this.apiUrl}/follows?modelId=${opts.modelId}&modelType=${opts.modelType}`;
    return this.http.delete(url);
  }

  favourite(opts: any): Observable<any> {
    opts = Object.assign(opts, {level: 1});
    const url = `${this.apiUrl}/follows/level`;
    return this.http.put(url, opts);
  }
}
